module.exports = __webpack_public_path__ + "img/ico_6.7799bc80.png";